import { Button } from '@creditornot/cb-button';
import { ModalContent, ModalFooter, ModalHeader } from '@creditornot/cb-modal';
import { pick } from 'lodash';
import keyBy from 'lodash/keyBy';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { WoltModal } from 'common/components';
import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';

import { VenueRowItem } from './VenueRowItem';
import { SELF_DELIVERY_VENUES_NOT_ALLOWED } from '../../constants';
import { useCampaignModuleContext } from '../../context';
import { VenuesValidationError } from '../../types';

const StyledWoltModal = styled(WoltModal)`
  display: flex;
  flex-direction: column;
  width: 640px;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    min-width: auto;
    width: 98vw;
  }
`;
const StyledFooter = styled(ModalFooter)`
  justify-content: flex-end;
  gap: 16px;
`;
const StyledModalContent = styled(ModalContent)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const UnsupportedVenuesModal = ({
  isOpen,
  venuesValidationErrors,
  onClose,
  onConfirm,
}: {
  isOpen: boolean;
  venuesValidationErrors: VenuesValidationError;
  onClose(): void;
  onConfirm(): void;
}) => {
  const { venues: merchantVenues } = useCampaignModuleContext();

  const { reason, venueIds } = venuesValidationErrors;
  const venues = Object.values(pick(keyBy(merchantVenues, 'id'), venueIds));

  return (
    <StyledWoltModal isOpen={isOpen}>
      <ModalHeader onCloseClick={onClose}>
        <FormattedMessage id={'campaigns.form.venues.unsupported-venues-modal.title'} />
      </ModalHeader>
      <StyledModalContent>
        <div>
          <FormattedMessage
            id={
              reason === SELF_DELIVERY_VENUES_NOT_ALLOWED
                ? 'campaigns.form.venues.unsupported-venues-modal.self-delivery-reason'
                : 'campaigns.form.venues.unsupported-venues-modal.dynamic-reason'
            }
            values={{
              reason,
            }}
          />
          <br />
          <br />
          <FormattedMessage id="campaigns.form.venues.unsupported-venues-modal.continue-description" />
        </div>
        {venues.map(venue => (
          <VenueRowItem key={venue.id} venueSelectItem={venue} />
        ))}
      </StyledModalContent>
      <StyledFooter>
        <Button variant="lightBlue" size="small" onClick={onClose}>
          <FormattedMessage id="campaigns.form.venues.cancel" />
        </Button>
        <Button variant="blue" size="small" onClick={onConfirm}>
          <FormattedMessage id="campaigns.form.create-campaign" />
        </Button>
      </StyledFooter>
    </StyledWoltModal>
  );
};

export default UnsupportedVenuesModal;
